import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  groupLink: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.pxToRem(13),
    fontWeight: theme.typography.fontWeightBold,
    '&:hover': {
      color: theme.palette.text.primary,
    },
  },
  tooltip: {
    backgroundColor: 'rgba(97, 97, 97, 0.9)',
    '& a': {
      color: '#FFF',
    },
  },
  differentTimezone: {
    color: '#F56A00',
  },
  vehicleGroup: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: theme.typography.fontWeightBold,
    maxHeight: '100%',
    maxWidth: 180,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textAlign: 'left',
    textOverflow: 'ellipsis',
  },
  location: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: theme.typography.fontWeightMedium,
    maxHeight: '100%',
    maxWidth: 180,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textAlign: 'left',
    textOverflow: 'ellipsis',
  },
  serviceArea: {
    fontSize: theme.typography.pxToRem(13),
    maxHeight: '100%',
    maxWidth: 180,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textAlign: 'left',
    textOverflow: 'ellipsis',
  },
  vehicle: {
    alignItems: 'flex-start !important',
    display: 'flex',
    flexDirection: 'column',
    fontSize: theme.typography.pxToRem(13),
    maxWidth: 250,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
  },
  timezoneIcon: {
    color: '#F56A00',
    fontSize: theme.typography.pxToRem(10),
    marginLeft: 3,
  },
  vehicleTitle: {
    alignItems: 'center',
    display: 'flex',
    lineHeight: theme.typography.pxToRem(11),
  },
  timezoneContainer: {
    alignItems: 'center',
    display: 'flex',
  },
  timezone: {
    lineHeight: theme.typography.pxToRem(11),
  },
  selectedGroup: {
    backgroundColor: theme.palette.primary.main,
    '& a': {
      color: theme.palette.common.white,
      '&:hover': {
        color: theme.palette.common.white,
        fontWeight: 'bold',
      },
    },
  },
  group: {
    height: '100%',
    maxHeight: 65,
    overflow: 'hidden',
    padding: '0',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    width: '100%',
    whiteSpace: 'nowrap',
  },
  calendarSidebar: {
    borderRight: '1px solid #E0E0E0',
    backgroundColor: '#fbfbfb',
    display: 'flex',
    height: 54,
  },
  sidebarColumn: {
    alignItems: 'center',
    color: theme.palette.text.primary,
    display: 'flex',
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightMedium,
    justifyContent: 'center',
    maxHeight: '100%',
    maxWidth: '100%',
    textAlign: 'center',
  },
  sidebarFirstColumn: {
    borderRight: '1px solid #E0E0E0',
  },
  vgColumn: {
    borderRight: '1px solid #E0E0E0',
    justifyContent: 'flex-start !important',
  },
  vgInfo: {
    fontSize: theme.typography.pxToRem(13),
  },
  calendarContainer: {
    '& .rct-header-root': {
      backgroundColor: '#FFF',
      border: '1px solid #E0E0E0',

      '& .rct-calendar-header': {
        backgroundColor: '#fbfbfb',
        border: 'none',
        color: theme.palette.text.primary,

        '& div:first-child': {
          '& .rct-dateHeader': {
            backgroundColor: '#fbfbfb !important',
            borderBottomWidth: '0px !important',
            borderLeft: 'none',
            color: theme.palette.text.primary,
            fontSize: theme.typography.pxToRem(10),
            fontWeight: theme.typography.fontWeightMedium,
            wordBreak: 'break-word',
            textAlign: 'center',
            height: 54,
          },
        },
        '& div:last-child': {
          '& .rct-dateHeader': {
            backgroundColor: '#FFF',
            borderLeftWidth: '0px !important',
          },
        },
      },
    },
    '& .rct-outer': {
      backgroundColor: '#FFF',
      borderColor: '#E0E0E0',
      borderStyle: 'solid',
      borderWidth: '0px 1px 1px 1px',

      '& .rct-sidebar': {
        border: 'none',
        color: theme.palette.text.primary,

        '& .rct-sidebar-row': {
          backgroundColor: '#FFF',
          borderColor: '#E0E0E0',
          borderRight: '1px solid #E0E0E0',
          color: theme.palette.text.primary,
          fontSize: theme.typography.pxToRem(13),
          height: '65px !important',
          padding: 0,
          textAlign: 'center',
        },
      },

      '& .rct-scroll': {
        '& .rct-vertical-lines': {
          backgroundColor: '#FFF',
          '& .rct-vl': {
            backgroundColor: 'transparent',
            borderLeft: '1px solid #E0E0E0',
          },
        },
        '& .rct-horizontal-lines': {
          '& .rct-hl-even': {
            backgroundColor: '#FFF',
            borderBottom: '1px solid #E0E0E0',
          },
          '& .rct-hl-odd': {
            backgroundColor: '#FFF',
            borderBottom: '1px solid #E0E0E0',
          },
        },
      },
    },
  },
}));

export default useStyles;
